import {SvgIcon, SvgIconProps} from '@ui/icons/svg-icon';
import clsx from 'clsx';
import {LucideProps} from 'lucide-react';
import {forwardRef, ForwardRefExoticComponent, Ref, RefAttributes} from 'react';

// wrapper for lucide icon svg inner contents (<path>, <rect>, <circle>, etc.)
export const LucideIconWrapper = forwardRef<SVGSVGElement, SvgIconProps>(
  ({children, size = 'md', strokeWidth = 2, ...props}, ref) => {
    return (
      <SvgIcon
        fill="fill-none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        size={size}
        {...props}
        ref={ref}
      >
        {children}
      </SvgIcon>
    );
  },
);

// wrapper for full lucide svg react component
type Props = {
  icon: ForwardRefExoticComponent<
    Omit<LucideProps, 'ref'> & RefAttributes<SVGSVGElement>
  >;
  size?: SvgIconProps['size'];
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
  ref?: Ref<SVGSVGElement>;
};
export const LucideIcon = function ({
  icon,
  size = 'md',
  strokeWidth = 2,
  className,
  ref,
  style,
}: Props) {
  const Icon = icon;
  return (
    <Icon
      strokeWidth={strokeWidth}
      className={clsx(className, sizeToIconClassName(size))}
      ref={ref}
      style={style}
    />
  );
};

function sizeToIconClassName(size: SvgIconProps['size']) {
  switch (size) {
    case '2xs':
      return 'icon-2xs';
    case 'xs':
      return 'icon-xs';
    case 'sm':
      return 'icon-sm';
    case 'md':
      return 'icon-md';
    case 'lg':
      return 'icon-lg';
    case 'xl':
      return 'icon-xl';
    default:
      return size;
  }
}
